import React, { useEffect } from 'react'; // eslint-disable-next-line
import { Row, Col, Card, CardBody, CardHeader, Button, Image } from 'react-bootstrap'; // eslint-disable-next-line
import { copiriPortalRequest, getLanguagePackUrl } from '../api/api'; // eslint-disable-next-line
import config from '../../config'; // eslint-disable-next-line
import CopiriLoader from '../common/CopiriLoader';
import lockIcon from '../../assets/img/icons/lock.png';
import no_gl_seal_light from '../../assets/img/logos/no_gl_seal_light.png';
import Footer from './Footer';
const ElectionVotingClosed = props => {
	const { pageLanguageContent, votingData } = props;
	useEffect(() => {
		// eslint-disable-next-line
	}, []);

	return (
		<Row className='row g-0 mx-0 fontInter'>
			{/* Left Side - Blue Card */}
			<Col md={6} className='pl-0'>
				<div className='voting-left d-flex flex-column justify-content-between p-4'>
					<div className='content'>
						<span className='badge-election'>
							<i className='fas fa-check-to-slot'></i>{' '}
							{pageLanguageContent['VOT008'] ? pageLanguageContent['VOT008'] : ''}
						</span>
						<h5 className='mt-4 text-white'>
							<Image
								src={votingData.organization_icon ? votingData.organization_icon : no_gl_seal_light}
								alt={votingData?.organization_name}
							/>{' '}
							{votingData?.organization_name}
						</h5>
						<h2 className='text-white'>{votingData?.title}</h2>
						<p className='text-white mt-3'>{votingData?.description}</p>
					</div>
					<Footer pageLanguageContent={pageLanguageContent} votingData={votingData} />
				</div>
			</Col>

			{/* Right Side - Voting Message */}
			<Col md={6} className='rightContest d-flex flex-column justify-content-between'>
				<div className='text-center'>
					{votingData?.contest_number && votingData?.contest_total && (
						<span className='contestBadge'>
							{pageLanguageContent['VOT016']
								? pageLanguageContent['VOT016']
										.replace('_contest_number_', votingData?.contest_number)
										.replace('_contest_total_', votingData?.contest_total)
								: ''}
						</span>
					)}
					<h4>
						<Image
							src={votingData.contest_icon ? votingData.contest_icon : no_gl_seal_light}
							alt={votingData?.contest_name}
						/>
						{votingData?.contest_name}
					</h4>
				</div>

				<div className='vottingStatus'>
					<span className='lockIcon'>
						<Image src={lockIcon} alt={votingData?.status_text} />
					</span>
					<span className='Voting-is-open'>{votingData?.status_text}</span>
				</div>
			</Col>
		</Row>
	);
};
export default ElectionVotingClosed;
